import StartListTabContent from './StartListTabContent';

export default StartListTabContent;